import * as actions from './tasks/actions'
import * as mutations from './tasks/mutations'
import * as getters from './tasks/getters'

import { dataProps } from './tasks/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    group_task: [],
    show_task_group_form: false,
    show_task_form: false
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tasks.js